export type DownloadPlatform = "windows" | "macos" | "unsupported";

type UserAgentHints = {
  platform?: string;
  architecture?: string;
  bitness?: string;
};

type NavigatorForDetection = Pick<Navigator, "userAgent" | "platform" | "maxTouchPoints"> & {
  userAgentData?: {
    platform?: string;
    getHighEntropyValues?: (hints: string[]) => Promise<UserAgentHints>;
  };
};

export async function detectDownloadPlatform(navigatorValue: NavigatorForDetection): Promise<DownloadPlatform> {
  const userAgent = navigatorValue.userAgent || "";
  const reportedPlatform = navigatorValue.userAgentData?.platform || navigatorValue.platform || "";
  const mobileApple = /iPhone|iPad|iPod/i.test(userAgent)
    || (/Mac/i.test(reportedPlatform) && navigatorValue.maxTouchPoints > 1);

  if (mobileApple || /Android|Mobile/i.test(userAgent)) return "unsupported";

  if (/Windows|Win32|Win64/i.test(`${userAgent} ${reportedPlatform}`)) {
    const highEntropy = await navigatorValue.userAgentData?.getHighEntropyValues?.(["architecture", "bitness"]);
    if (highEntropy?.architecture && !/x86|x64|amd64/i.test(highEntropy.architecture)) return "unsupported";
    if (highEntropy?.bitness && highEntropy.bitness !== "64") return "unsupported";
    return "windows";
  }

  if (/Macintosh|MacIntel|MacPPC|Mac68K/i.test(`${userAgent} ${reportedPlatform}`)) return "macos";
  return "unsupported";
}
